import React from "react";
import { useTranslation } from "react-i18next";
import PageBody from "shared/components/layout/PageBody";
import PageContent from "shared/components/layout/PageContent";
import { PageHeader } from "shared/components/layout/PageHeader";
import { PageTabs } from "shared/components/layout/PageTabs";

export const InternalProvisioningPage: React.FC = () => {
  const { t } = useTranslation(["internal"]);

  return (
    <PageContent isFullHeight={true}>
      <PageHeader title={t("internal:provisioning")} />
      <PageBody>
        <PageTabs />
      </PageBody>
    </PageContent>
  );
};
